import { z } from 'zod';
/**
 * Delete Org Member Request Schema
 * DELETE /api/v2/org-members/:id
 */ export const DeleteOrgMemberRequestSchema = z.object({});
/**
 * Delete Org Member Response Schema
 * DELETE /api/v2/org-members/:id
 */ export const DeleteOrgMemberResponseSchema = z.object({
    success: z.boolean()
});

//# sourceMappingURL=delete-org-member.schema.js.map